import { LocalStorageHelpers } from "@ai360/core";

/**
 * True when the app should authenticate against the sky Cognito user pool
 * (the `sky*` fields of GetIdpConfig) instead of the default pool. Two ways
 * to trigger this:
 *
 * 1. Local development: requires the Vite dev server (import.meta.env.DEV)
 *    with VITE_USE_SKY_IDP=true (`npm run start:sky` sets this).
 * 2. Runtime: a non-null, parseable USER_INFO_KEY entry in localStorage.
 *    NOTE: unlike (1), this path is NOT dev-gated and applies to production
 *    builds as well.
 */
export const isSkyIdpForced = (env: ImportMetaEnv = import.meta.env): boolean => {
    if (Boolean(env.DEV) && env.VITE_USE_SKY_IDP === "true") {
        return true;
    }
    try {
        return JSON.parse(LocalStorageHelpers.get("USER_INFO_KEY") ?? "null") != null;
    } catch {
        return false;
    }
};
